import Home from '../home'

export default function HomeSecondary() {
    return (
        <Home stickyNavbar={true} />
    )
}
